export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.293 4.293a1 1 0 011.414 0l6 6-1.414 1.414L8 6.414l-5.293 5.293-1.414-1.414 6-6z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};